import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
export default (state = null, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_CURRENT_ORGANIZATION_CHANGE:
            return action.data
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/omnitecReducers/omnitecCurrentOrganisation.js